<template>
  <nav>
    <slot />
  </nav>
</template>
